

<div class="fx-col" id="prod-details">
  <div class="color-b">
    <div class="container main">
      <div class="details-wrapper p-20 fx-row">
        <div class="fx-col fx-flex-100">
          <div class="fx-row lt-lg-fx-col fx-flex-100-in-col lt-lg-fx-gap-bottom-20px print-fx-gap-right-20px gt-md-fx-gap-right-20px">
            <div class="fx-col xs-fx-flex-48-in-col sm-fx-flex-52-in-col md-fx-flex-65-in-col print-fx-flex-70 gt-md-fx-flex-70">
              <div class="prodBox cursor-pointer fx-flex-100-in-col"  (click)="goToslider(product.ItemID)">
                <img [src]="env.imageUrl +product.ImageUrl" alt="" class="img-bg" style="width: 80% !important;">
              </div>
            </div>
            <div class="m-b-30 fx-col fx-main-start fx-cross-start xs-fx-flex-52-in-col sm-fx-flex-48-in-col md-fx-flex-38-in-col print-fx-flex-30 gt-md-fx-flex-30">
              <div class="product-right w-100 m-t-30">
                <div >
                  <span class="product-title" [textContent]="$safeNavigationMigration(product?.ProductName)"></span>
                  @if (!productsService?.catalogMode && product && product.Prices) {
                    <p class="price f-s-14 f-w-400">
                    {{product?.Prices[0] && product?.Prices[0].Price | currency:companyService.selectedCurrency.CurrencyCode}}</p>
                  }
                </div>
                <hr style="margin:28px 0px; border-color:rgba(0,0,0,0.1)">
                <div class="product_detail_qv">
                  <!-- <span [innerHTML]="product?.Description"></span> -->
                </div>
                <div class="price-column">
                  <div class="price" [textContent]="getPrice(product, OrderQuantityCount) | currency:companyService.selectedCurrency.CurrencyCode">
                  </div>
                  @if (product?.AllowAutoship && (product?.Price - product?.AutoshipPrice > 0)) {
                    <span translate
                    [translateParams]="{value:(product.Price - product.AutoshipPrice | currency:companyService.selectedCurrency.CurrencyCode)}">subscribe_autoship</span>
                  }
                </div>
                <div class="price-column">
                  <p> {{'global_pv'|translate}}<span> :
                  {{OrderQuantityCount * (product?.CV || product?.QV || 0)}}</span></p>
                </div>
                @if (product?.HasOptions) {
                  <div class="layout-row fx-row">
                    <div class="w-100 checkoptionbox">
                      @for (option of product?.ItemOptions; track option; let i = $index) {
                        <div class="m-0 p-20-0 custom-size checkoptionbox">
                          <p [textContent]="option.Option" class="f-w-700 text"></p>
                          <mat-form-field   appearance="outline">
                            <mat-label>Select {{option.Option}}</mat-label>
                            <mat-select readonly="true" [(ngModel)]="value[i]"
                              (selectionChange)="checkOptions($safeNavigationMigration(product?.ItemOptions));" name="value.Option"
                             
                              (click)="openSelect($event)"
                              class="md-no-underline-select">
                              @for (value of getValidValues(product, option, option.Values); track value) {
                                <mat-option
                                  (ngInit)="setInitialItemOption(option, value)" [value]="value.Option"
                                  (click)="value.isAvailable && selectOption(product, option, value, false)">
                                {{value.Option}} </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                      }
                    </div>
                  </div>
                }
                <div class="quantity">
                  <span class="f-w-700">Quantity</span>
                  <div class="text-muted fx-row xs-fx-col">
                    <div class="fx-row fx-main-center fx-cross-start">
                      <button [disabled]="(!isOptionsSelected && product?.HasOptions && product?.ItemOptions?.length>0)"
                        mat-icon-button matTooltip="Remove" (click)="decreaseQuantity()">
                        <mat-icon>remove</mat-icon>
                      </button>
                      <input [(ngModel)]="OrderQuantityCount" maxlength="2" validate
                        [disabled]="!isOptionsSelected && product?.HasOptions && product.ItemOptions && product.ItemOptions?.length>0"
                        inputonlynumber="true" name="quantity"
                        (keyup)="($event.which === 38) ? increaseQuantity() : 0"
                        (keydown)="($event.which === 40) ? decreaseQuantity() : 0"
                        class="form-control input-number">
                      <button [disabled]="(!isOptionsSelected && product?.HasOptions && product.ItemOptions && product?.ItemOptions.length>0)"
                        mat-icon-button matTooltip="Add" (click)="increaseQuantity()">
                        <mat-icon>add</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="buttons mt-20">
                  @if (!hideAddToCart(product) && !(persistentService.retailData.CurrentSelectedAutoOrder > 0 && utilityService.getAutoshipEditFlag())) {
                    <button
                      [disabled]="product?.HasOptions && !isOptionsSelected && product?.ItemOptions?.length>0"
                      mat-raised-button color="primary" class="btn-project w-100"
                      (click)="addToCart('order', product)"
                    translate="">{{'global_addtocart' | translate}}</button>
                  }
                  @if (hideAddToCart(product, true)) {
                    <button [disabled]="product?.HasOptions && !isOptionsSelected && product?.ItemOptions?.length>0"
                      mat-raised-button color="primary" class="btn-project w-100 m-t-10"
                    (click)="addToCart('autoship', product)" translate="">{{'autoship_' | translate}}</button>
                  }
                </div>
              </div>
              <div class="prodReview product-right w-100">
                <!-- <mat-accordion>
                <mat-expansion-panel hideToggle (opened)="panelOpenSpecification = true" (closed)="panelOpenSpecification = false" hideToggle="true">
                  <mat-expansion-panel-header>
                    <mat-icon class="c-gray" *ngIf="!panelOpenSpecification">add</mat-icon>
                    <mat-icon class="c-gray" *ngIf="panelOpenSpecification">remove</mat-icon>
                    <span class="color-f-s-14" translate="product_details"></span>
                  </mat-expansion-panel-header>
                  <div class="review-wrapper" fxFlex="100" fxFlex.md="75" [innerHtml]="product?.Description | unsafe">

                  </div>
                </mat-expansion-panel>
              </mat-accordion> -->
              <mat-accordion>
                <mat-expansion-panel class="font-IBM fx-row-in-expansion-panel">
                  <mat-expansion-panel-header class="arrow-color">
                    <mat-panel-title>
                      <span class="f-s-14 f-w-700 question font-IBM" translate="product_details"></span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <p class="font-IBM" class="review-wrapper fx-flex-100 md-fx-flex-75" [innerHtml]="$safeNavigationMigration(product?.Description) | unsafe"></p>
                </mat-expansion-panel>
                @if (product.AllowAutoship) {
                  <mat-expansion-panel class="font-IBM fx-row-in-expansion-panel">
                    <mat-expansion-panel-header class="arrow-color">
                      <mat-panel-title>
                        <span class="f-s-14 f-w-700 question font-IBM" translate="autoship_"></span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <!-- <p class="font-IBM" class="review-wrapper" fxFlex="100" fxFlex.md="75"  [innerHtml]="'autoship_description'| translate | unsafe"></p> -->
                    <p class="font-IBM" class="review-wrapper fx-flex-100 md-fx-flex-75"  [innerHtml]="$safeNavigationMigration(product?.Specifications) | unsafe"></p>
                  </mat-expansion-panel>
                }
              </mat-accordion>
            </div>
            <!-- <div *ngIf="product.AllowAutoship" class="prodReview" style="margin-top:0px !important">
            <mat-accordion>
              <mat-expansion-panel hideToggle (opened)="panelOpenAutoship = true" (closed)="panelOpenAutoship = false" hideToggle="true">
                <mat-expansion-panel-header>
                  <mat-icon class="c-gray" *ngIf="!panelOpenAutoship">add</mat-icon>
                  <mat-icon class="c-gray" *ngIf="panelOpenAutoship">remove</mat-icon>
                  <span class="color-f-s-14" translate="autoship_"></span>
                </mat-expansion-panel-header>
                <div class="review-wrapper" fxFlex="100" fxFlex.md="75" [innerHtml]="'autoship_description'| translate | unsafe">

                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div> -->
        </div>
      </div>
      <hr style="margin:28px 0px; border-color:rgba(0,0,0,0.1)">
      <div class="products sec-padding p-top-0">
        <div>
          <div class="fx-col">
            <div class="m-t-10 fx-col gt-xs-fx-row fx-main-start fx-cross-start fx-fill-size fx-flex-in-col print-fx-gap-bottom-20px xs-fx-gap-bottom-20px gt-xs-fx-gap-right-20px"
              >
              <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
                <div class="img-hover text-center">
                  <p class="f-s-18 f-w-700 m-t-10">Free shipping</p>
                  <p class="f-s-14 f-w-400 m-t-10">All orders over $100 come with complimentary free shipping. Simply check out normally.</p>
                </div>
              </div>
              <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
                <div class="img-hover text-center">
                  <p class="f-s-18 f-w-700 m-t-10">Effortless Returns</p>
                  <p class="f-s-14 f-w-400 m-t-10">Each package comes with a prepaid return label. You've got sixty days to send it back.</p>
                </div>
              </div>
              <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-33 print-fx-flex-33-in-col">
                <div class="img-hover text-center">
                  <p class="f-s-18 f-w-700 m-t-10">Gift Cards</p>
                  <p class="f-s-14 f-w-400 m-t-10">Not sure what to get as a gift? Grab a gift card and use it at any one of our retail locations.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- perfect stretch -->
      <div class="m-t-20">
        <div class="fx-col">
          <div class="bg-img p-relative fx-col fx-main-center fx-cross-stretch fx-flex-50-in-col">
            <img src="https://cdn.shopify.com/s/files/1/0926/9298/files/AV200723_SH05_059.jpg?v=1600978896&width=1512" alt="image">
            <div class="content p-abs c-white">
              <div class="p-relative p-content-div">
                <p><span class="f-s-12">Our Gaurentee</span></p>
                <p class="m-t-12 f-s-36 f-w-700">The Perfect Stretch</p>
                <p class="m-t-20 w-35">Each Energy Well pieces comes tested in 360 degree flexibility tests. That's how we gaurentee the perfect stretch.</p>
                <p class="m-t-30 shop-btn"  routerLink="/products/all"><a class="c-black f-s-14">Shop now</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr style="margin:28px 0px; border-color:rgba(0,0,0,0.1)">
      <!--Recommended-->
      <div class="p-30">
        <div class="fx-col">
          <p class="f-s-24 f-w-700">Recommended</p>
          <div class="m-t-10 fx-col gt-xs-fx-row fx-main-start fx-cross-start fx-fill-size fx-flex-100-in-col print-fx-gap-bottom-20px xs-fx-gap-bottom-20px gt-xs-fx-gap-right-20px"
            >
            @for (productImage of healthBeautyProduct; track productImage; let i = $index) {
              <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size xs-fx-flex-100-in-col sm-fx-flex-100 gt-sm-fx-flex-32 print-fx-flex-32-in-col"
                >
                <div (mouseover)="mouseEnter(i)"
                  (mouseout)="mouseOut(i)" class="p-relative cursor-pointer fx-col fx-main-center fx-cross-center fx-fill-size fx-flex-70-in-col lt-md-fx-flex-100-in-col"  id="parent">
                  <img (click)="goToShop(productImage.ItemID)" [src]="env.imageUrl +productImage.ImageUrl" alt="" class="img-bg2" [id]="'product'+i" style="width: 100% !important;">
                  <!-- <img [src]="productImage.url" alt="" class="img-bg d-none" [id]="'products'+i" style="width: 100% !important;"> -->
                  <div class="content fx-col fx-main-end fx-cross-stretch fx-fill">
                    <div class="p-absolute abs-width">
                      <button [id]="'btn'+i" class="shop-btn product-button d-none w-89 m-t-20 m-b-20 m-r-0 m-l-0"
                      mat-raised-button color="black"  (click)="addProduct(productImage)">Quick Add</button>
                    </div>
                  </div>
                </div>
                <div class="content m-t-20 fx-row fx-flex-10-in-col">
                  <div class="fx-flex-70">
                    <p><span class="font-IBM">{{productImage.ProductName}}</span></p>
                    <p><span class="m-t-10 font-IBM">@if (productImage.oldPrice) {
                      <del>{{productImage.oldPrice}} </del>
                    }
                  {{'$'+productImage.Price}}</span></p>
                </div>
                @if (productImage.oldPrice) {
                  <div class="text-end m-t-10 fx-flex-30">
                    <p class="f-s-12 sale" color="white">Sale</p>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
</div>
